@use '@lib/assets/styles/main.scss' as *;

.root {
  display: block;
  position: relative;
  z-index: 0;
  transition: background-color .3s ease, border .3s ease, color .3s ease, filter .3s ease;
  user-select: none;
  overflow: hidden;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }

  svg {
    display: block;
  }
}

.root:disabled {
  cursor: default;
}

.ripple {
  position: absolute;
  z-index: 1;
  transform: scale(0);
  border-radius: 50%;
  animation: ripple 0.6s linear;
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

.icon,
.loader {
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.iconHidden {
  opacity: 0;
}

.counter {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 3;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  background-color: $blue500;
  color: $gray0;
  font-family: 'Inter', sans-serif;
  font-size: 8px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  white-space: nowrap;
}
